import axios from "axios";
import store from "../store";

class Actions
{
    // TODO get by "tiers"

    async GetById(id) {
		let jwt = store.state.jwt;

		let result = await axios
			.get(`${process.env.VUE_APP_SAAS_BACK}/actions/${id}`, {
				headers: { Authorization: "Bearer " + jwt },
			})
			.then((response) => {
				if (
					response.status === 200 &&
					response.data.action
				) {
					let result = response.data.action;

					return result
				}
				return response;
			})
			.catch((err) => {
				console.log("Error getting action: ", err);
				return {err};
			});

		return result;
	}

    async GetAll() {
        let jwt = store.state.jwt;

        let result = await axios
            .get(`${process.env.VUE_APP_SAAS_BACK}/actions`, {
                headers: { Authorization: "Bearer " + jwt },
            })
            .then((response) => {
                if (
                    response.status === 200 &&
                    response.data.actions
                ) {
                    let result = response.data.actions;

                    return result;
                }
                return null;
            })
            .catch((err) => {
                console.log("Error getting actions: ", err);
                return {err};
            });

        return result;
    }

    async Create(action)
    {
        let jwt = store.state.jwt;

        let result = await axios
            .post(
                `${process.env.VUE_APP_SAAS_BACK}/actions`,
                {
                    action,
                },
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then((response) => {
                response.data.status = 201;
                return response.data;
            })
            .catch((err) => {
                console.log("Error creating action: ", err);
                return { err: err };
            });

        return result;
    }

    async Update(action)
    {
        let jwt = store.state.jwt;

        let result = await axios
            .put(
                `${process.env.VUE_APP_SAAS_BACK}/actions/${action.id}`,
                {
                    action,
                },
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then((response) => {
                console.log("Updated response: ", response);
                response.status = 204;
                return response;
            })
            .catch((err) => {
                console.log("Error updating action: ", err);
                return { err: err };
            });

        return result;
    }

    async Delete(action)
    {
        let jwt = store.state.jwt;

        let result = await axios
            .delete(
                `${process.env.VUE_APP_SAAS_BACK}/actions/${action.id}`,
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                console.log("Error deleting action: ", err);
                return { err: err };
            });

        return result;
    }

    async CreateOrUpdate(action)
    {
        if (action.id === undefined) {
            return this.Create(action);
        } else {
            return this.Update(action);
        }

    }
}

export default new Actions();